module.exports = __webpack_public_path__ + "assets/b66.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b66.png
// module id = 656
// module chunks = 0